var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "2 4 28 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#707070",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.076 4a2.77 2.77 0 0 1 2.77 2.77v18.46a2.77 2.77 0 0 1-2.77 2.77H4.923a2.77 2.77 0 0 1-2.77-2.77V6.77A2.77 2.77 0 0 1 4.923 4zm.923 4.615h-24v16.616c0 .51.415.923.923.923h22.154c.51 0 .923-.414.923-.923V8.615z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.153 10.462v13.846H5.845V10.462h20.308zm-.923.923H6.768v12H25.23v-12z"
}))));
export default SvgDocumentIcon;